import React, { useState } from 'react';
import axios from 'axios';
import { useSearchParams, Link } from 'react-router-dom';
import { Mail, Lock, CheckCircle } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;
const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(' ');
  return 'Algo salió mal. Intenta de nuevo.';
};

const Shell = ({ title, children }) => (
  <div className="min-h-screen flex items-center justify-center p-6" style={{ background: 'var(--sendhapy-smoke)' }}>
    <div className="w-full max-w-md bg-white rounded-2xl shadow-sm p-8">
      <a href="/"><img src="/sendhapy-logo-badge.png" alt="SendHapy" className="h-11 w-auto mb-6" /></a>
      <h1 className="text-2xl font-bold mb-2" style={{ color: 'var(--sendhapy-teal)' }}>{title}</h1>
      {children}
    </div>
  </div>
);

const inputCls = 'w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-600 outline-none';
const btnStyle = { background: 'var(--sendhapy-yellow)', color: 'var(--sendhapy-teal)' };

export function RecuperarPassword() {
  const [email, setEmail] = useState('');
  const [msg, setMsg] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      const { data } = await axios.post(`${API}/api/cliente/recuperar`, { email });
      setMsg(data.message);
    } catch (err) { setError(errMsg(err)); } finally { setLoading(false); }
  };
  return (
    <Shell title="¿Olvidaste tu contraseña?">
      {msg ? <p className="text-gray-700 flex gap-2" data-testid="recuperar-ok"><CheckCircle className="text-green-600 shrink-0" /> {msg}</p> : (
        <form onSubmit={submit} className="space-y-4" data-testid="recuperar-form">
          <p className="text-sm text-gray-600">Escribe el correo de tu cuenta y te enviaremos un enlace para crear una nueva contraseña.</p>
          <div className="relative"><Mail size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
            <input data-testid="recuperar-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} placeholder="tu@correo.com" /></div>
          {error && <p className="text-sm text-red-600" data-testid="recuperar-error">{error}</p>}
          <button data-testid="recuperar-submit-button" disabled={loading} className="w-full py-3 rounded-lg font-semibold disabled:opacity-50" style={btnStyle}>{loading ? 'Enviando...' : 'Enviar enlace'}</button>
        </form>
      )}
      <Link to="/cliente" className="block text-sm mt-6 hover:underline" style={{ color: 'var(--sendhapy-teal)' }} data-testid="recuperar-volver">Volver a iniciar sesión</Link>
    </Shell>
  );
}

export function RestablecerPassword() {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');
  const [msg, setMsg] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) return setError('La contraseña debe tener al menos 8 caracteres.');
    if (pw !== pw2) return setError('Las contraseñas no coinciden.');
    setLoading(true); setError('');
    try {
      const { data } = await axios.post(`${API}/api/cliente/restablecer`, { token, password: pw });
      setMsg(data.message);
    } catch (err) { setError(errMsg(err)); } finally { setLoading(false); }
  };
  return (
    <Shell title="Crea una nueva contraseña">
      {msg ? <p className="text-gray-700 flex gap-2" data-testid="restablecer-ok"><CheckCircle className="text-green-600 shrink-0" /> {msg}</p> : !token ? (
        <p className="text-sm text-red-600" data-testid="restablecer-sin-token">El enlace no es válido. Solicita uno nuevo.</p>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="restablecer-form">
          {[[pw, setPw, 'Nueva contraseña (mínimo 8 caracteres)', 'restablecer-password-input'], [pw2, setPw2, 'Repite la contraseña', 'restablecer-password2-input']].map(([v, set, ph, id]) => (
            <div key={id} className="relative"><Lock size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
              <input data-testid={id} type="password" required minLength={8} value={v} onChange={(e) => set(e.target.value)} className={inputCls} placeholder={ph} /></div>
          ))}
          {error && <p className="text-sm text-red-600" data-testid="restablecer-error">{error}</p>}
          <button data-testid="restablecer-submit-button" disabled={loading} className="w-full py-3 rounded-lg font-semibold disabled:opacity-50" style={btnStyle}>{loading ? 'Guardando...' : 'Guardar contraseña'}</button>
        </form>
      )}
      <Link to="/cliente" className="block text-sm mt-6 hover:underline" style={{ color: 'var(--sendhapy-teal)' }} data-testid="restablecer-ir-login">Ir a iniciar sesión</Link>
    </Shell>
  );
}
